import React, { useEffect, useRef } from "react";
import { Editor } from "primereact/editor";

export const ReadOnlyTextArea = ({
  data, cab, hijos, campokey, indiceData, type, context,
  id_elemento, valor
}) => {
  const nombre = cab.nombre_alias ? data[cab.nombre_alias] : cab.nombre;
  const dynamicClasses = (data[cab.id_a + "_className"] ?? cab.className) || "";
  const prev = useRef([]);

  const applyClasses = () => {
    const root = document.getElementById(id_elemento);
    if (!root) return false;
    const ql = root.querySelector(".ql-editor");
    if (!ql) return false;

    // limpiar anteriores
    prev.current.forEach(c => c && ql.classList.remove(c));

    // aplicar nuevas
    const next = dynamicClasses.split(/\s+/).filter(Boolean);
    next.forEach(c => ql.classList.add(c));
    prev.current = next;

    // console.log("[ReadOnlyTextArea] clases aplicadas:", next);
    return true;
  };

  useEffect(() => {
    // intentar ahora
    if (applyClasses()) return;

    // si aún no existe .ql-editor, observar hasta que aparezca
    const root = document.getElementById(id_elemento);
    if (!root) return;

    const obs = new MutationObserver(() => {
      if (applyClasses()) obs.disconnect();
    });
    obs.observe(root, { childList: true, subtree: true });

    return () => obs.disconnect();
  }, [id_elemento, dynamicClasses, valor]);

  return (
    <div
      id={id_elemento}
      style={{ width: "100%" }}
      className="tarjeta_grid_item_label_item d-flex flex-column align-items-start"
    >
      {nombre ? <div className="vista_label">{nombre}:</div> : null}
      <Editor
        id={`${id_elemento}__editor`}  // evitar IDs duplicados
        value={valor ?? data[campokey]}
        readOnly
        disabled
        theme="bubble"
        style={{ border: "1px solid #fff0", width: "100%" }}
        className="w-100"
      />
    </div>
  );
};
